import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { SearchCompanyUserAction } from '../../../redux/actions/user';

import { ContainerForm } from '../../../components/Containers';
import ButtonBack from '../../../components/ButtonBack';
import { MessageBoxAlert, MessageBoxError } from '../../../components/MessageBox';
import WrapperListHeader from '../../../components/User/WrapperListHeader';
import { WrapperContainerCards } from '../../../components/User/WrapperContainerCards';
import InputSearch from '../../../components/InputSearch';
import CardUserList from '../../../components/User/CardUserList';
import { WrapperInputs } from '../../../components/SincronizaNFe/WrapperInputs';
import SelectCompanyList from '../../../components/Company/SelectCompanyList';

export default function CompanyListUsers() {
  const [searchUser, setSearchUser] = useState('');
  const [selectCompanyList, setSelectCompanyList] = useState('');
  const {
    searchCompanyUser,
    error: errorSearchCompanyUser,
    loading: loadingSearchCompanyUser,
  } = useSelector((state) => state.searchCompanyUser);
  const dispatch = useDispatch();

  const filteredUsers = searchUser
    ? searchCompanyUser.filter((user) => {
        return user.name.toLowerCase().includes(searchUser.toLowerCase());
      })
    : searchCompanyUser;

  useEffect(() => {
    if (errorSearchCompanyUser === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [errorSearchCompanyUser]);

  useEffect(() => {
    if (selectCompanyList !== '') {
      dispatch(SearchCompanyUserAction(selectCompanyList));
    }
  }, [dispatch, selectCompanyList]);

  return (
    <ContainerForm>
      <WrapperListHeader />
      <WrapperInputs>
        <ButtonBack />
        <SelectCompanyList setSelectCompanyList={setSelectCompanyList} />
      </WrapperInputs>
      {selectCompanyList !== '' && (
        <InputSearch placeholder="Digite o nome do usuário para acha-lo" state={searchUser} setState={setSearchUser} />
      )}
      <WrapperContainerCards>
        {filteredUsers &&
          filteredUsers.map((user, index) => {
            return <CardUserList key={index + 1} user={user} />;
          })}
        {filteredUsers && filteredUsers.length === 0 && (
          <MessageBoxAlert>Não há usuários com esse nome</MessageBoxAlert>
        )}
      </WrapperContainerCards>
      {errorSearchCompanyUser && <MessageBoxError>{errorSearchCompanyUser}</MessageBoxError>}
      {loadingSearchCompanyUser && <MessageBoxAlert>Escolha uma empresa para listar</MessageBoxAlert>}
    </ContainerForm>
  );
}
